// DisclosureController
app.controller('DisclosureController', ['$scope', 'seotags',
    function($scope, seotags) {

        $scope.init = async function() {
            $scope.showPageLoader();
            await $scope.fetchAdviserSiteDetails();
            $scope.hidePageLoader();
            $scope.disclaimer = true;
            $scope.termsCondition = false;
            $scope.privacyPolicy = false;

            $scope.disclosureSelected = 'Disclaimer';
            $scope.disclosureList = ['Disclaimer', 'Terms of Use', 'Privacy Policy'];
        }

        $scope.dropDownselected = function() {
            if ($scope.disclosureSelected == 'Disclaimer') {
                $scope.disclaimer = true;
                $scope.termsCondition = false;
                $scope.privacyPolicy = false;
            } else if ($scope.disclosureSelected == 'Terms of Use') {
                $scope.termsCondition = true;
                $scope.disclaimer = false;
                $scope.privacyPolicy = false;
                // $scope.wealthBaskets = false;
            } else if ($scope.disclosureSelected == 'Privacy Policy') {
                $scope.privacyPolicy = true;
                $scope.disclaimer = false;
                $scope.termsCondition = false;
            }
        }       
    }
]);